import React, { useContext, useState } from 'react';
import AlertImageContext from '../../context/AlertImageContext';
import AlldataComp from '../../context/AlldataComp';
import LoadingTailwindContext from '../../context/LoadingTailwindContext'
import ViewContext from '../../context/ViewContext';
import { Modal } from 'react-bootstrap';
import "../../Styles/AlertImageCom.css";
import { useEffect } from 'react';
import { Message } from '@mui/icons-material';

function AlertImageComp() {
    const [show, setShow] = useState(true);
    const [dataAlldataComp,] = useContext(AlldataComp);
    const data = useContext(AlertImageContext)
    const [dataLoadingTailwind, setdataLoadingTailwind] = useContext(LoadingTailwindContext);
    const handleClose = () => setShow(false);
    const [, setdataView] = useContext(ViewContext);

    // const handleShow = () => setShow(true);
    let message = 'Fin del flujo';
    const handleCorregir = () => {
        setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
        setdataView('END');
        setShow(false)
        window.parent.postMessage(message, "*");
    }
    useEffect(() => {
        window.parent.postMessage(message, "*");
    }, [])

    return (
        <>
            <Modal show={show} size="lg" backdrop="static" onHide={handleClose} centered className="modalConfirm_mail">

                <Modal.Body>
                    {/* {JSON.stringify(dataAlldataComp)}
                    {JSON.stringify(dataAlldataComp.Contact.Correo)} */}
                    <div className='message_confirm'>
                        <p className='message_confirm_subject'>¡Último paso! Confirma tu <br /> correo electrónico!</p>
                    </div>
                    <div className='message_confirm'>
                        <p className='message_confirm_text'>Para continuar con tu proceso de inscripción te hemos enviado un <br /> correo para qué concluyas tu trámite</p>
                    </div>
                    <div className='message_confirm' onClick={handleCorregir}>
                        <a className='form_button_new btn btn-primary' href={`mailto:${dataAlldataComp.Contact.Correo}`}>Revisar correo </a>
                    </div>
                </Modal.Body>
            </Modal>

            {/* <Card className="card-principal">
                <Card.Body className="card-body-principal">
                <Row>
                <Col sm={12} md={6} lg={6} className='mb-4 col-alert-image'>
                    <Card className="card-alert-img">
                        <Image src={data[0].src} alt="Image" />
                    </Card>
                </Col>
                <Col sm={12} md={6} lg={6} className='mb-4 col-alert-image'>
                    <Card className="card-alert-img">
                        <Card.Header className="text-center card-header-alert-img">
                            <h3>{data[0].title}</h3>
                        </Card.Header>
                        <Card.Body>
                            <Container>
                                <p>{data[0].body}</p>
                                <p>{data[0].body2}</p>
                                {
                                    data[0].scneario === "F" ?
                                        (
                                            <ul className="list-fullerette">
                                                <li>Número de Fullerette: {data[0].dataFullerette.NumeroFullerette === undefined || data[0].dataFullerette.NumeroFullerette === '' ? "No proporcionado" : data[0].dataFullerette.NumeroFullerette} </li>
                                                <li>Zona: {data[0].dataFullerette.Zona === 0 || data[0].dataFullerette.Zona === undefined ? "No Proporcionado" : data[0].dataFullerette.Zona} </li>
                                                <li>Gerente: {
                                                    data[0].dataGerente.Nombre === undefined || data[0].dataGerente.Nombre === '' ? "No Proporcionado" : data[0].dataGerente.Nombre
                                                }</li>
                                                <li>Teléfono: {
                                                    data[0].dataGerente.AGSTEL === 0 || data[0].dataGerente.AGSTEL === '' ? "No Proporcionado" : data[0].dataGerente.AGSTEL
                                                }</li>
                                            </ul>
                                        ) :
                                        (
                                            <h4 className="font-weight-bold" >{data[0].bodyfotter}</h4>
                                        )
                                }
                            </Container>
                        </Card.Body>
                        

                    </Card>
                </Col>
            </Row>
                </Card.Body>
                {
                            data[0].scneario === "F" ?
                                (
                                    <Card.Footer className="footer-fullerette">
                                        <h6 className="text-white" > Puedes comprar nuestros productos en </h6>
                                        <a target="_blank" rel="noopener noreferrer" className="text-white" href="https://fuller.com.mx/">www.fuller.com.mx</a>
                                    </Card.Footer>
                                ) : null
                                
                        }
                        
                        {
                            data[0].scneario === "P" ?
                                (
                                    <Card.Footer className="footer-prospecto">
                                        <h6 className="text-white" > Puedes comprar nuestros productos en </h6>
                                        <a target="_blank" rel="noopener noreferrer" className="text-white" href="https://fuller.com.mx/">www.fuller.com.mx</a>
                                    </Card.Footer>
                                ) : null
                                
                        }
                        
                        {
                            data[0].scneario === "E" ?
                                (
                                    <Card.Footer className="footer-end">
                                        <h6 className="text-white" > Puedes comprar nuestros productos en </h6>
                                        <a target="_blank" rel="noopener noreferrer" className="text-white" href="https://fuller.com.mx/">www.fuller.com.mx</a>
                                    </Card.Footer>
                                ) : null
                                
                        }
                         {
                            data[0].scneario === "FC" ?
                                (
                                    <Card.Footer className="footer-fuera-cobertura">
                                        <h6 className="text-white" > Puedes comprar nuestros productos en </h6>
                                        <a target="_blank" rel="noopener noreferrer" className="text-white" href="https://fuller.com.mx/">www.fuller.com.mx</a>
                                    </Card.Footer>
                                ) : null
                                
                        }
            </Card> */}

        </>
    )
}
export default AlertImageComp;